import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useCancelPlanMutation } from 'app/api/planApiSlice';
import TSButton from 'components/common/Button/Button';
import MLToast from 'components/common/Toast/Toast';

// Asks before cancelling a Planned Plan. A Cancelled Plan stays in My Plans
// but can't be started or changed again.
const CancelPlan = ({ plan, toggleModal }) => {
  const { showToast } = MLToast();
  const [cancelPlan, { isLoading }] = useCancelPlanMutation();

  const handleCancel = async () => {
    const res = await cancelPlan(plan.plan_id);
    if (res.data) {
      showToast('Plan cancelled', 'success');
      toggleModal(false);
    } else {
      showToast(res.error?.data?.message || 'Something went wrong!', 'error');
    }
  };

  return (
    <div>
      <Typography variant="h2">Cancel this Plan?</Typography>
      <Typography variant="body1" className="pt-3">
        {plan.trail_name} on {dayjs(plan.planned_date).format('ddd D MMM YYYY')}
        . You won't be able to start it or change it afterwards.
      </Typography>
      <div className="grid grid-cols-2 gap-3 mt-6">
        <TSButton
          btnText={isLoading ? 'Cancelling...' : 'Cancel Plan'}
          btnColor="error"
          btnDisable={isLoading}
          onClickFunc={handleCancel}
        />
        <TSButton
          btnText="Keep Plan"
          btnVariant="outlined"
          onClickFunc={() => toggleModal(false)}
        />
      </div>
    </div>
  );
};

export default CancelPlan;
